import React from 'react';
import styled from 'styled-components';
import propTypes from 'prop-types';
import breakpointsMinWidth from '../../../../../../../../../styling/breakpointsMinWidth';

const LogoWrapper = styled.div`
  display: ${(props) => (props.showImage ? 'flex' : 'none')};
  pointer-events: auto;
  grid-column: 1/2;
  grid-row: 1/-1;
  position: relative;
  justify-content: center;
  align-items: center;
  width: 92px;
  height: 92px;
  background: #ffffff;
  border: 1px solid #e5e5e5;
  box-sizing: border-box;
  border-radius: 4px;
  user-select: none;
  -webkit-user-select: none;

  @media ${breakpointsMinWidth.tabletSm} {
    width: 80px;
    height: 80px;
  }
  @media ${breakpointsMinWidth.tabletLg} {
    width: 92px;
    height: 92px;
  }
  @media ${breakpointsMinWidth.desktopMd} {
    width: 100px;
    height: 100px;
  }
`;

const Logo = ({ nodeProps, showImage }) => {
  const { attributes, children } = nodeProps;
  return (
    <LogoWrapper showImage={showImage} {...attributes} contentEditable={false}>
      {children}
    </LogoWrapper>
  );
};

Logo.propTypes = {
  nodeProps: propTypes.objectOf(propTypes.object).isRequired,
  attributes: propTypes.objectOf(propTypes.string).isRequired,
};

export default Logo;
